"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../ControlRendererContext"));
const CameraQRender_1 = __importDefault(require("../ControlRenderer/components/CameraQRender"));
const LoadingPageRenderer_1 = __importDefault(require("../ControlRenderer/components/LoadingPageRenderer"));
const InputDialogRenderer_1 = __importDefault(require("../ControlRenderer/components/InputDialogRenderer"));
const AlertRenderer_1 = __importDefault(require("../ControlRenderer/components/AlertRenderer"));
const AdMobInterstitialAdsRenderer_1 = __importDefault(require("../ControlRenderer/components/AdMobInterstitialAdsRenderer"));
const ApplicationContext_1 = __importDefault(require("../PageBooter/ApplicationContext"));
const PageBooter_1 = __importDefault(require("../PageBooter"));
const WithStyleFormaterContext_1 = __importDefault(require("../components/WithStyleFormaterContext"));
const ConfirmAlertRenderer_1 = __importDefault(require("../ControlRenderer/components/ConfirmAlertRenderer"));
const ImageViewerRenderer_1 = __importDefault(require("../ControlRenderer/components/ImageViewerRenderer"));
const RenderPagesByRouting_1 = __importDefault(require("../components/RenderPagesByRouting"));
const styles = {
    view: {
        display: 'flex',
        flex: 1,
        width: '100%',
        backgroundColor: '#83a6df',
        alignItems: 'center',
        justifyContent: 'center',
    },
    text: {
        color: 'rgb(0, 36, 119)',
        fontSize: 15,
        textAlign: 'center',
        fontWeight: 'bold',
    },
};
const AppRenderer = ({ buildOrders, freeAppBannerHeight = 0, routeStack, sideMenuContext, bottomMenuContext, cameraContext, inputDialogContext, alertContext, confirmAlertContext, loadingPageContext, adMobInterstitialAdsContext, imageViewerContext, }) => {
    var _a, _b;
    const { functions: { processor }, Render, dimentions } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const pages = (0, react_1.useMemo)(() => buildOrders.pages, [buildOrders.pages]);
    const insidePageElement = (0, react_1.useMemo)(() => {
        var _a;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            (cameraContext === null || cameraContext === void 0 ? void 0 : cameraContext.isOpened) && (react_1.default.createElement(CameraQRender_1.default, { cameraContext: cameraContext })),
            (inputDialogContext === null || inputDialogContext === void 0 ? void 0 : inputDialogContext.isOpened) && (react_1.default.createElement(InputDialogRenderer_1.default, { inputDialogContext: inputDialogContext })),
            (alertContext === null || alertContext === void 0 ? void 0 : alertContext.isOpened) && (react_1.default.createElement(AlertRenderer_1.default, { alertContext: alertContext })),
            (confirmAlertContext === null || confirmAlertContext === void 0 ? void 0 : confirmAlertContext.isOpened) && (react_1.default.createElement(ConfirmAlertRenderer_1.default, { confirmAlertContext: confirmAlertContext })),
            (loadingPageContext === null || loadingPageContext === void 0 ? void 0 : loadingPageContext.isOpened) && (react_1.default.createElement(LoadingPageRenderer_1.default, { src: (loadingPageContext === null || loadingPageContext === void 0 ? void 0 : loadingPageContext.lottieUrl)
                    || ((_a = buildOrders.configurations) === null || _a === void 0 ? void 0 : _a.loadingLottieSrc) })),
            (adMobInterstitialAdsContext === null || adMobInterstitialAdsContext === void 0 ? void 0 : adMobInterstitialAdsContext.isOpened) && (react_1.default.createElement(AdMobInterstitialAdsRenderer_1.default, { adMobInterstitialAdsContext: adMobInterstitialAdsContext })),
            (imageViewerContext === null || imageViewerContext === void 0 ? void 0 : imageViewerContext.isOpened) && (react_1.default.createElement(ImageViewerRenderer_1.default, { imageViewerContext: imageViewerContext }))));
    }, [
        cameraContext,
        inputDialogContext,
        alertContext,
        confirmAlertContext,
        buildOrders.configurations,
        loadingPageContext,
        adMobInterstitialAdsContext,
        imageViewerContext,
    ]);
    const sideMenu = (_a = buildOrders.menus) === null || _a === void 0 ? void 0 : _a.sideMenu;
    const applicationContext = (0, react_1.useMemo)(() => ({
        sideMenu,
        sideMenuContext,
        bottomMenuContext,
        insidePageElement: insidePageElement || null,
    }), [
        sideMenu,
        sideMenuContext,
        bottomMenuContext,
        insidePageElement,
    ]);
    const pagesWrapper = (0, react_1.useMemo)(() => ({
        position: 'relative',
        backgroundColor: 'transparent',
        width: dimentions.window.width,
        height: dimentions.window.height - freeAppBannerHeight,
    }), [dimentions.window.width, dimentions.window.height, freeAppBannerHeight]);
    const initialPageId = (0, react_1.useMemo)(() => {
        const foundInitialPage = Object.entries(pages || {})
            .find(([, page]) => page && page.initialPage) || [];
        return foundInitialPage[0];
    }, [pages]);
    if (initialPageId && processor) {
        processor.root.routing.boot(initialPageId);
    }
    if (!initialPageId) {
        return (react_1.default.createElement(Render.View, { style: styles.view },
            react_1.default.createElement(Render.Text, { style: styles.text }, "Application has not initial page")));
    }
    if (!pages) {
        return (react_1.default.createElement(Render.View, { style: styles.view },
            react_1.default.createElement(Render.Text, { style: styles.text }, "Application has not pages")));
    }
    return (react_1.default.createElement(WithStyleFormaterContext_1.default, { fontSize: buildOrders.fontSize, shadeBases: (_b = buildOrders === null || buildOrders === void 0 ? void 0 : buildOrders.palette) === null || _b === void 0 ? void 0 : _b.shadeBases },
        react_1.default.createElement(ApplicationContext_1.default.Provider, { value: applicationContext },
            react_1.default.createElement(Render.View, { style: pagesWrapper },
                react_1.default.createElement(RenderPagesByRouting_1.default, { routeStack: routeStack, rendererPage: (route) => {
                        var _a;
                        if (!routeStack) {
                            return null;
                        }
                        const page = (_a = buildOrders.pages) === null || _a === void 0 ? void 0 : _a[route.pageId];
                        const focusedPageKey = routeStack[routeStack.length - 1].key;
                        const isFocused = focusedPageKey === route.key;
                        if (!page) {
                            return null;
                        }
                        return (react_1.default.createElement(PageBooter_1.default, { key: route.key, page: page, transition: route.transition, isFocused: isFocused }));
                    } })))));
};
exports.default = AppRenderer;
